//import React, { useState, useEffect } from 'react';
import HeaderTitle from '../../../components/typography/header-title';
//import HeaderTitle from '../../components/typography/header-title';
//import Home from '../../components/securityComponent/home';
export default function AdminDashboard() {
    return (
        <>
            <HeaderTitle
                title={'Admin Dashboard'}
                subtitle={
                    'Have track on access provided to users'
                }
            />
            <div>Coming Soon</div>
        </>
    );
}
